import React, { Fragment } from 'react';

import { range } from 'lodash';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import { CATEGORY_ROW_H, HEADER_H, LEFT_W, SOURCE_ROW_H } from './roadmapGeometry';

const SOURCE_COUNT = 3;
const CATEGORIES_PER_SOURCE = 4;

// Placeholder for the Roadmap grid while the first fetch is in flight: dark source bands with
// grey category rows under each, and bars at varying offsets across the timeline.
const RoadmapSkeleton = () => (
    <Fragment>
        <span role="status" className="tw-sr-only">
            {$t('Loading...')}
        </span>
        <SkeletonTheme borderRadius="0.25rem">
            <div
                className="tw-relative tw-overflow-hidden tw-h-[70vh] tw-min-h-[240px] tw-border tw-border-charcoal-25 tw-rounded-lg tw-bg-white"
                aria-hidden="true"
                dir="ltr"
            >
                <div className="tw-flex tw-bg-blue-10 tw-border-b tw-border-charcoal-25" style={{ height: HEADER_H }}>
                    <div className="tw-shrink-0 tw-bg-white tw-border-e tw-border-charcoal-25" style={{ width: LEFT_W }} />
                </div>

                {range(SOURCE_COUNT).map((source) => (
                    <Fragment key={source}>
                        <div className="tw-flex tw-items-center tw-bg-charcoal tw-border-b tw-border-charcoal" style={{ height: SOURCE_ROW_H }}>
                            <div className="tw-flex tw-items-center tw-shrink-0 tw-px-4" style={{ width: LEFT_W }}>
                                <div className="tw-h-3 tw-rounded tw-bg-charcoal-75" style={{ width: `${45 + ((source * 11) % 25)}%` }} />
                            </div>
                        </div>

                        {range(CATEGORIES_PER_SOURCE).map((category) => {
                            const row = source * CATEGORIES_PER_SOURCE + category;

                            return (
                                <div
                                    key={category}
                                    className="tw-flex tw-items-center tw-bg-charcoal-10 tw-border-b tw-border-grey"
                                    style={{ height: CATEGORY_ROW_H }}
                                >
                                    <div
                                        className="tw-shrink-0 tw-px-4 tw-border-e tw-border-charcoal-25 tw-h-full tw-flex tw-items-center"
                                        style={{ width: LEFT_W }}
                                    >
                                        <Skeleton containerClassName="tw-flex-1" height={12} width={`${35 + ((row * 7) % 30)}%`} />
                                    </div>
                                    <div className="tw-flex-1 tw-px-2.5">
                                        <Skeleton height={20} width={`${12 + ((row * 13) % 18)}%`} style={{ marginInlineStart: `${(row * 17) % 60}%` }} />
                                    </div>
                                </div>
                            );
                        })}
                    </Fragment>
                ))}
            </div>
        </SkeletonTheme>
    </Fragment>
);

export default RoadmapSkeleton;
